import { createFileRoute } from '@tanstack/react-router'

import {
  getTaxonomyOptions,
  getTaxonomyVersionOptions,
} from '@/api/codegen/@tanstack/react-query.gen'
import { TaxonomyVersionPage } from '@/pages/taxonomy/TaxonomyVersion.page'

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/taxonomies/$taxonomyId/$taxonomyVersionId',
)({
  component: TaxonomyVersionPage,
  loader: async ({
    context: { queryClient },
    params: { spaceId, taxonomyId, taxonomyVersionId },
  }) => {
    const taxonomy = await queryClient.ensureQueryData(
      getTaxonomyOptions({
        path: {
          spaceID: spaceId,
          taxonomyID: taxonomyId,
        },
      }),
    )
    const taxonomyVersion = await queryClient.ensureQueryData(
      getTaxonomyVersionOptions({
        path: {
          spaceID: spaceId,
          taxonomyID: taxonomyId,
          taxonomyVersionID: taxonomyVersionId,
        },
      }),
    )

    return {
      breadcrumbTitle: `${taxonomy.name} - V.${taxonomyVersion.version}`,
    }
  },
})
